module.exports = __webpack_public_path__ + "img/full4-min.e7170ec5.png";